// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.5 2H2V22H22V2H17.5V9.875H6.5V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5 2H8.5V7.875H15.5V2ZM14 4V7H12V4H14Z"}}]};

const HardDiskStorageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hard-disk-storage-filled',
    ref,
    icon: element,
  },
));

HardDiskStorageFilledIcon.displayName = 'HardDiskStorageFilledIcon';

export default HardDiskStorageFilledIcon;
